module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Районы\n    "), (_vm.total) ? _c('span', [_vm._v("(" + _vm._s(_vm.total) + ")")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'district-add'
      }
    }
  }, [_vm._v("+ Добавить район")])], 1), _vm._v(" "), _c('resource-list', {
    attrs: {
      "url": "/districts",
      "current-sort": "name",
      "resource-name": "districts",
      "show-per-page": false,
      "action-routes": _vm.actionRoutes,
      "fields": _vm.fields,
      "filters": _vm.filters
    },
    on: {
      "total": _vm.updateTotal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6244eff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/district/Districts.vue
// module id = 657
// module chunks = 0